/* ============================================================
   MAHYA — ACCORDION RESILIENCE FIX
   ------------------------------------------------------------
   Custom (non-<details>) accordions in product-block-accordion
   stop responding after:
     - mineral-powder-navigator's ajaxSwap (section.replaceWith)
     - theme's shade-variant change (state/listener corruption)

   This script takes OWNERSHIP of `.accordion__label` clicks
   using a document-level capture-phase delegated listener.
   - Document never goes away, so the listener never dies.
   - Capture phase + stopImmediatePropagation runs BEFORE the
     theme's (now-broken) handler and prevents it from firing
     conflicting state updates.

   Where to put this:
     1. Save as: assets/accordion-fix.js
     2. In theme.liquid, just before </body>, add:
          <script src="{{ 'accordion-fix.js' | asset_url }}" defer></script>
     That's it. No other config needed.
   ============================================================ */

(function () {
  'use strict';
  var LOG = '[mahya-accordion-fix]';

  // Internal toggle — also used by the popstate / section-swap rehydration below.
  function toggle(btn, force) {
    var inner = btn.closest('.accordion__inner');
    if (!inner) return;
    var content = inner.querySelector('.accordion__content');
    if (!content) return;

    var currentOpen = btn.getAttribute('aria-expanded') === 'true';
    var nextOpen = (force === true || force === false) ? force : !currentOpen;

    btn.setAttribute('aria-expanded', String(nextOpen));
    inner.setAttribute('data-open', String(nextOpen));
    content.setAttribute('aria-hidden', String(!nextOpen));
    content.style.display = nextOpen ? 'block' : 'none';
  }

  // Capture-phase listener on document — survives ANY DOM replacement.
  // stopImmediatePropagation kills the theme's competing handler.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.accordion__label');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    toggle(btn);
  }, true);

  // Optional: re-apply initial open-state after a section swap.
  // The accordion liquid renders `data-default-expanded="{{ open }}"` and
  // inline `style="display: ..."`. After a swap, the new HTML has correct
  // initial state, so usually nothing to do — but this guarantees alignment
  // with aria-expanded on the button in case anything got out of sync.
  function rehydrate(root) {
    (root || document).querySelectorAll('.accordion__inner').forEach(function (inner) {
      var btn = inner.querySelector('.accordion__label');
      var content = inner.querySelector('.accordion__content');
      if (!btn || !content) return;
      // Defer to data-default-expanded as the source of truth on rehydrate.
      var defaultOpen = content.getAttribute('data-default-expanded') === 'true';
      // Only force-reset if there's an obvious mismatch between button & content.
      var btnSays  = btn.getAttribute('aria-expanded') === 'true';
      var contentShown = content.style.display !== 'none' && content.getAttribute('aria-hidden') !== 'true';
      if (btnSays !== contentShown) {
        toggle(btn, defaultOpen);
      }
    });
  }

  // Re-sync on Shopify section load (theme editor + your navigator's dispatch).
  document.addEventListener('shopify:section:load', function (e) {
    rehydrate(e.target);
    console.log(LOG, 'rehydrated after shopify:section:load');
  });

  // Also re-sync when the navigator does its ajaxSwap (custom event).
  document.addEventListener('mp:section:swapped', function (e) {
    rehydrate(document);
    console.log(LOG, 'rehydrated after mp:section:swapped');
  });

  console.log(LOG, 'ready — accordion clicks now owned at document/capture');
})();
